import RedeemPointsMethods from './RedeemPointsMethods';

export default RedeemPointsMethods;
